import React from "react";

import i18n from "../../../constants/i18n";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import AuditorsEventsForm from "./auditors-events-form";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import AuditorsEventsData from "./auditors-events-data";

const AuditorsEvents = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "AUDITOR_EVENTS_DATA",
      "AUDITOR_EVENTS_DATA"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("AUDITOR_EVENTS_DATA")}
        subTitle={i18n.get("AUDITOR_EVENTS_DATA")}
        withRefresh={false}
        onPress={() => {}}
        withHelper={false}
      />
      <AuditorsEventsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <AuditorsEventsData />
    </ET3PageDiv>
  );
});
export default AuditorsEvents;
